import { render, staticRenderFns } from "./CertifiedChecks.vue?vue&type=template&id=78858f83&"
import script from "./CertifiedChecks.vue?vue&type=script&lang=js&"
export * from "./CertifiedChecks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports